const R = require('ramda');

export default (obj, reqProps) => {
  return obj && R.none(_ => _ === undefined, R.props(reqProps, obj));
};



// WEBPACK FOOTER //
// ./src/Detail/objectExistsAndHasProps/index.js